
const THEME_CLASS_PREFIX = 'theme--';

function getSectionThemeClasses() {
    const panel = document.querySelector('[data-theme-scope]');
    if (!panel) return [];

    return [...panel.classList].filter((cls) => cls.startsWith(THEME_CLASS_PREFIX));
}

function applyThemeClassesToHeader(themeClasses) {
    const header = document.querySelector('.header');
    if (!header) return;

    // Remove any existing theme classes from the header
    const existing = [...header.classList].filter((cls) => cls.startsWith(THEME_CLASS_PREFIX));
    if (existing.length) {
        header.classList.remove(...existing);
    }

    if (themeClasses.length) {
        header.classList.add(...themeClasses);
    }
}

export default function initSectionTheme() {
    const themeClasses = getSectionThemeClasses();
    if (themeClasses.length) {
        applyThemeClassesToHeader(themeClasses);
    }
}
